import { useMemo } from 'react';

import { formatDateForAPI } from '@/utils/dates.utils';

import type { ConsumerViewParams } from '../types/consumer.types';

import useConsumerStore from '../store/consumer.store';

export const useConsumerViewParams = (): ConsumerViewParams | null => {
  const { dateRange, company, cups } = useConsumerStore();

  return useMemo((): ConsumerViewParams | null => {
    if (!dateRange?.[0] || !dateRange?.[1]) return null;

    return {
      startDate: formatDateForAPI(dateRange[0]),
      endDate: formatDateForAPI(dateRange[1]),
      companies: company ? [company.id] : [],
      cups: cups.map((c) => c.identifier).sort(),
    };
  }, [dateRange, company, cups]);
};
